import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=1faced89&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports